import React, { memo } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { SimulationResultData } from 'routes/HumanResourcesModule/business/types';
import HrChart from 'routes/HumanResourcesModule/components/HrChart/HrChart';
import { getEchartOptions } from '../helpers/eChartHelpers';

type Props = {
    cardHeaderActions: React.ReactNode;
    groupBy: keyof SimulationResultData;
    isLoading: boolean;
    isMonthly: boolean;
    resultSimulationData: SimulationResultData[];
    titleNode: React.ReactNode;
};

const ResultGraph = ({
    cardHeaderActions,
    groupBy,
    isLoading,
    isMonthly,
    resultSimulationData,
    titleNode,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const options = getEchartOptions(
        resultSimulationData,
        groupBy,
        isMonthly,
        t,
    );

    return (
        <HrChart
            title={t('humanResources.simulation.resultsBy')}
            isLoading={isLoading}
            cardHeaderActions={cardHeaderActions}
            options={options}
            titleNode={titleNode}
        />
    );
};

export default memo(ResultGraph, _.isEqual);
